module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAECAYAAADmrJ2uAAAARklEQVQoU83RYRFAUBCF0fOS0IAoojwJiEgCJFmzf1RYt8B3Zm6LiAUbZrW7sbaIuDDWWr76kaCUDT8BnQnKy3ZMxagH/QUU7xQ4KqFgFwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/close1.png
// module id = D6xy
// module chunks = 1